import Model from '../../ModelBinding/Model';
import CriticalityCollection from './CriticalityCollection';

export default class Contact extends Model {
  public inherit?: boolean;
  public level?: number;
  public organization_id?: string;

  bind() {
    this.inherit = this.getBooleanAttribute('inherit');
    this.level = this.getIntAttribute('level');
    this.organization_id = this.getStringAttribute('organization_id');
  }

  static getCollection() {
    return CriticalityCollection;
  }
}
